import Icon from 'Components/Atoms/Icon/Icon';
import Spinner from 'Components/Atoms/Spinner';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

const typeIcons = {
    warning: <Icon name="circle-alert" color="currentColor" className="text-warning" />,
    info: <Icon name="circle-info" color="currentColor" className="text-primary" />,
};

export default function Notice(props) {
    const { className, type = 'warning', children, action, gutterBottom, onClose } = props;

    const icon = typeIcons[type] || null;

    return (
        <div
            className={cn(
                'bg-gray-100 rounded-md',
                {
                    'bg-warning/10': type === 'warning',
                    'bg-[#F44854]/10': type === 'error',
                    'bg-primary/10': type === 'info',
                    'mb-8': gutterBottom,
                },
                className,
            )}
            role="alert"
        >
            <div className="flex items-start md:items-center gap-3 py-4 px-3">
                <div className="shrink-0">{icon}</div>
                <div className="grow text-dark-blue flex flex-col md:flex-row md:justify-between md:items-center gap-x-10 gap-y-2">
                    <div className="grow text-sm">{children}</div>
                    {action && (
                        <div>
                            <button
                                type="button"
                                className="py-1 inline-flex items-center gap-1.5 text-sm font-medium text-dark-blue group relative"
                                onClick={action.onClick}
                            >
                                {action.isBusy && (
                                    <span className="absolute inset-0 flex items-center justify-center">
                                        <Spinner size={24} />
                                    </span>
                                )}

                                <span
                                    className={cn(
                                        'inline-flex items-center gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:first:-ml-1',
                                        {
                                            'opacity-0': action.isBusy,
                                        },
                                    )}
                                >
                                    {action.label}
                                </span>
                            </button>
                        </div>
                    )}
                </div>
                {onClose && (
                    <button
                        type="button"
                        className="shrink-0 p-1 text-dark-blue/80 hover:text-dark-blue transition-colors"
                        onClick={onClose}
                    >
                        <Icon name="close" size={20} color="currentColor" />
                    </button>
                )}
            </div>
        </div>
    );
}

Notice.propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(['warning', 'error', 'info']),
    children: PropTypes.node.isRequired,
    action: PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        onClick: PropTypes.func.isRequired,
        isBusy: PropTypes.bool,
    }),
    gutterBottom: PropTypes.bool,
    onClose: PropTypes.func,
};
